import React from 'react';
import PropTypes from 'prop-types';
import { CheckBox, Icon, Button } from 'Components';
import './TestConfigModalTemplateHeader.css';

const ClassName = (extra = '') => `test-config-modal-template-header${extra}`;

const TestConfigModalTemplateHeader = ({
  onSelectAllParameters,
  onToggleExpanded,
  data,
}) => {
  const allChecked = !data.some(parameter => !parameter.Checked);

  return (
    <thead className={ClassName()}>
      <tr className={ClassName`__dropdown`}>
        <th><CheckBox onClick={() => null} /></th>
        <th colSpan={2}>
          <div className={ClassName`__test-info`}>
            <div className={ClassName`__test-title`}>
              Biochemical Oxygen Demand (BOD)
            </div>
            <div>SM 23 5210B m</div>
            <div>B12345</div>
          </div>
        </th>
        <th>
          <Button onClick={onToggleExpanded}>
            <Icon icon="arrow_drop_down" />
          </Button>
        </th>
      </tr>
      <tr className={ClassName`__headers`}>
        <th />
        <th>PARAMETER</th>
        <th>DETECTION LIMIT</th>
        <th />
      </tr>
      <tr className={ClassName`__select-all`}>
        <th>
          <CheckBox
            checked={allChecked}
            onClick={onSelectAllParameters}
          />
        </th>
        <th colSpan={3}>Select All Parameters</th>
      </tr>
    </thead>
  );
};

TestConfigModalTemplateHeader.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    Checked: PropTypes.bool,
  })),

  onSelectAllParameters: PropTypes.func,
  onToggleExpanded: PropTypes.func,
};


export default TestConfigModalTemplateHeader;



// WEBPACK FOOTER //
// ./src/components/TestConfigModalTemplate/Header/TestConfigModalTemplateHeader.jsx